import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import es from "vuetify/es5/locale/es";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#00d471",
        secondary: "#00c177",
        accent: "#02d1a4",
        error: "#FF5252",
        info: "#21f3e2",
        success: "#4CAF50",
        warning: "#ffc107",
      },
    },
  },
  lang: {
    locales: { es },
    current: "es",
  },
});
